export default {
    loaded: ({user}) => user.loaded,
    user: ({user}) => user.user,
    logins: ({user}) => user.logins,
    pending_voucher: ({user}) => user.pending_voucher,
    deposit_bonus: ({user}) => user.deposit_bonus,
    welcome_bonus: ({user}) => user.welcome_bonus,
    kyc_profile: ({user}) => user.kyc_profile,
    welcome_bonus_details: ({user, app}) => {
        return {
            available: {
                affiliate: app.affiliate_bonus,
                referral: app.referral_bonus
            },
            way: user?.welcome_bonus?.details?.affiliate ? 'affiliate' : false,
            finalized: user?.welcome_bonus?.status === 2 ? true : false
        }
    },
    facebook: {
        profile: ({user}) => user.facebook.profile.profile,
        post:  ({user}) => user.facebook.profile.post,
        tasks:  ({user}) => user.facebook.profile.tasks,
        button: ({user}) => user.facebook.button,
        uncompleted_rewards: ({user}) => user.facebook.profile.uncompleted_rewards,
        active_bonus_time: ({user}) => user.facebook.profile.active_bonus_time,
    },
    isAuth: ({user}) => user.user !== null
}